<template>
  <span>
    <button :disabled="disabled" @click="showCalendar()" title="Calendar"  class="date-navigation__button gds-button gds-compact gds-button-outline">
      <svg class="gds-icon">
        <use xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-calendar" />
      </svg>
    </button>
  </span>
</template>

<script>
export default {
  name: "DateNavigationButtonCalendar",
  props: {
    showCalendar: Function,
    buttonLabel: String,
    disabled: Boolean
  }
};
</script>

<style scoped>
</style>